import { useDropzone } from "react-dropzone";
import { makeStyles, Grid } from "@material-ui/core";
import { Image as ImageIcon } from "@material-ui/icons";
import { MessageStore } from "store";
import Avatar from "../Avatar";

const useStyles = makeStyles((theme) => ({
  profileContainer: {
    width: 90,
    height: 90,
    border: "2px solid",
    borderColor: theme.palette.primary.main,
    borderRadius: 45,
    overflow: "hidden",
    position: "relative",
    userSelect: "none",
  },
  profileChange: {
    position: "absolute",
    width: 86,
    height: 86,
    borderRadius: 43,
    overflow: "hidden",
    backgroundColor: "rgba(0,0,0,0.7)",
    lineHeight: 96,
    opacity: 0,
    zIndex: 2,
    color: "#FFF",
    textAlign: "center",
    cursor: "pointer",
    transition: "opacity 300ms ease-in",
    userSelect: "none",
    "&:hover": {
      opacity: 1,
    },
  },
  profileIcon: {
    position: "absolute",
    top: "39%",
    left: "39%",
  },
}));

interface IProps {
  file?: File;
  onChange?: (file: File) => void;
}

const AvatarPhotoField = ({ file, onChange }: IProps) => {
  const classes = useStyles();

  const handleDrop = (files: File[]) => {
    if (!files || !files.length) return;

    const file = files[0];
    if (onChange) onChange(file);
  };

  const { getInputProps } = useDropzone({
    accept: ".jpg, .gif, .png, .gif",
    maxFiles: 1,
    maxSize: 512000,
    noDrag: true,
    onDrop: handleDrop,
    onDropRejected: (errors) => handleError(errors),
  });

  const handleClickProfile = () => {
    const el = document.getElementById("inputProfileAvatarImage");
    if (el) {
      el.click();
    }
  };

  function handleError(errors) {
    const fileErrors = errors[0].errors;
    if (fileErrors.length) {
      const type = fileErrors[0].code;
      if (type === "file-invalid-type") {
        MessageStore.warning(
          "Só são permitidos arquivos com extensão .jpg|.gif|.png."
        );
      } else if (type === "file-too-large") {
        MessageStore.warning(
          "Arquivo muito grande! Permitido apenas arquivos menores que 500KB."
        );
      } else if (type === "too-many-files") {
        MessageStore.warning("É permitido selecionar apenas um (1) arquivo.");
      }
    }
  }

  return (
    <>
      <input {...getInputProps()} id="inputProfileAvatarImage" />
      <Grid className={classes.profileContainer}>
        <Grid className={classes.profileChange} onClick={handleClickProfile}>
          <ImageIcon className={classes.profileIcon} fontSize="small" />
        </Grid>
        <Avatar file={file} size={86} />
      </Grid>
    </>
  );
};
export default AvatarPhotoField;
